import { TextField, TextFieldProps } from '@mui/material';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import strings from 'constants/index';

export function TextFormField<T extends FieldValues>({
  name,
  control,
  required,
  rules,
  defaultValue,
  label,
  helperText,
  ...textFieldProps
}: UseControllerProps<T> & TextFieldProps) {
  const {
    field: { value, onChange, ref, onBlur },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    rules: {
      ...(required
        ? { required: { value: true as const, message: strings.field_is_required } }
        : {}),
      ...rules,
    },
  });

  return (
    <TextField
      variant="standard"
      {...textFieldProps}
      id={name}
      data-testid={name}
      onChange={onChange}
      onBlur={onBlur}
      ref={ref}
      value={value !== undefined ? value : ''}
      label={label}
      error={!!error}
      helperText={error?.message || helperText}
      fullWidth
      required={required}
    />
  );
}
